import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  sortPeople
} from '../../../module/Sorting';
import './PeopleList.css';
import Person from '../Person';
import LoadingIndicator from '../../atoms/LoadingIndicator';
// import PointsChart from '../PointsChart';

const PeopleGrouping = ({arr, title}) => {
  if ( !arr.length ) return null;
  return (
    <div className={title.toLowerCase().replace(/\s/g, '-')}>
      <h4>{title}</h4>
      <div>
        {arr.map(person => {
          return (
            <Person key={person.personId} {...person} />
          );
        })}
      </div>
    </div>
  )
};

class PeopleList extends Component {

  constructor(...args) {
    super(...args);
    this.state = {
      attending: [],
      notAttending: [],
      unconfirmed: [],
    };
  }

  componentWillMount() {
    const {attending, notAttending, unconfirmed} = this.splitAndSortPeople(this.props.people);
    this.setState({
      attending,
      notAttending,
      unconfirmed,
    });
  }

  componentWillReceiveProps(nextProps) {
    const {attending, notAttending, unconfirmed} = this.splitAndSortPeople(nextProps.people);
    this.setState({
      attending,
      notAttending,
      unconfirmed,
    });
  }

  splitAndSortPeople(people) {
    const peopleSorted = sortPeople(people);
    return {
      attending: peopleSorted.filter(person => person.attending === true),
      notAttending: peopleSorted.filter(person => person.attending === false),
      unconfirmed: peopleSorted.filter(person => typeof person.attending !== "boolean"),
    };
  }

  render() {
    const {people, loading} = this.props;
    const {attending, notAttending, unconfirmed} = this.state;

    if ( loading && !(Object.keys(people).length>0) ) {
      return (
        <div>
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="PeopleList">
        {Object.keys(people).length > 0 ? (
          <div>
            {PeopleGrouping({arr: attending, title: "Attending"})}
            {PeopleGrouping({arr: unconfirmed, title: "Unconfirmed"})}
            {PeopleGrouping({arr: notAttending, title: "Not Attending"})}
            {/*<div>
              <PointsChart />
            </div>*/}
          </div>
        ) : (
          <p> No people have been added to the event yet. </p>
        )}
      </div>
    );
  }

}

PeopleList.propTypes = {
  people: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default PeopleList;



// WEBPACK FOOTER //
// ./src/component/organisms/PeopleList/component.js